import ApiClient from '../backend/ApiClient'
import { snackbar } from '../components/services/SnackbarService'
import affirm from '../core/Affirm'
import algo from '../core/Algo'
import { ITooltipData } from '../definitions/Tooltip'

class TooltipsManagerCLass {
    createTooltip = async (tooltip: ITooltipData): Promise<ITooltipData> => {
        affirm.hasValue(tooltip, 'Invalid Tooltip Data')

        try {
            const response = await ApiClient.createTooltip(tooltip)
            if (algo.hasVal(response)) {
                snackbar.show({ severity: 'success', text: `Tooltip ${tooltip.title} was created successfully` })
                return response
            }
        } catch (error) {
            console.error(`Error creating Tooltip: ${tooltip.title} `, error)
            snackbar.show({ severity: 'error', text: `Unable to create Tooltip : ${tooltip.title}` })
        }
    }

    getTooltip = async (uuid: string): Promise<ITooltipData> => {
        try {
            const response = await ApiClient.getTooltip(uuid)
            return response
        } catch (error) {
            console.error(`Error fetching tooltip ${uuid} data`, error)
        }
    }

    getTooltipByKey = async (tooltipKey: string): Promise<ITooltipData> => {
        try {
            const response = await ApiClient.getTooltipByKey(tooltipKey)
            return response
        } catch (error) {
            console.error(`Error fetching tooltip ${tooltipKey} data`, error)
        }
    }

    getAllTooltips = async (): Promise<ITooltipData[]> => {
        try {
            const response = await ApiClient.getAllTooltips()
            return response
        } catch (error) {
            console.error('Error fetching all Tooltips', error)
        }
    }

    deleteTooltip = async (uuid: string) => {
        affirm.hasValue(uuid, 'Invalid Tooltip Key')

        try {
            const response = await ApiClient.deleteTooltip(uuid)
            if (response) {
                snackbar.show({ severity: 'success', text: `Tooltip deleted successfully` })
            }
        } catch (error) {
            console.error(`Error deleting Tooltip ${uuid}: `, error)
        }
    }

    updateTooltip = async (tooltip: ITooltipData): Promise<ITooltipData> => {
        try {
            const response = await ApiClient.updateTooltip(tooltip)
            if (algo.hasVal(response)) {
                snackbar.show ({ severity: 'success', text: `Tooltip ${tooltip.title} updated successfully` })
                return response
            }
        } catch (error) {
            console.error(`Error updating Tooltip: ${tooltip.title} `, error)
            snackbar.show({ severity: 'error', text: `Unable to update Tooltip: ${tooltip.title}` })
        }
    }
}

const TooltipsManager = new TooltipsManagerCLass()
export default TooltipsManager
